export function isSafari() {
  const userAgent = navigator.userAgent;

  // 检查是否包含 Safari 和 AppleWebKit，但不包含 Chrome 或 Chromium
  return /Safari/.test(userAgent) && /AppleWebKit/.test(userAgent) && !/Chrome/.test(userAgent) && !/Chromium/.test(userAgent);
}

export function isHarmony() {
  const userAgent = navigator.userAgent;
  // 
  return /HarmonyOS/.test(userAgent);
}
